import { GET } from "./api";

export const ReadDrawerMenu = async (area, locale) => {
    const suffix = area ? `&area=${encodeURIComponent(area)}` : '';
    const localeSuffix = locale ? `&locale=${encodeURIComponent(locale)}` : '';
    return GET(`/side-menu?variant=drawer${suffix}${localeSuffix}`, true, { cache: 'no-store' });
};
